module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDUuNjUgNzAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZWJjMjQxO308L3N0eWxlPjwvZGVmcz48dGl0bGU+YW1hcmlsbGE8L3RpdGxlPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjQ1LjY1IiBoZWlnaHQ9IjcwIiByeD0iNS43MyIgcnk9IjUuNzMiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Amarilla.svg
// module id = 32PX
// module chunks = 94